import type {ReplaceMediaKind, ReplaceSourceSelection} from '@Components/media-source-menu/media-source-menu.types';

/** Prefixes the row ids so this menu stays distinguishable from the audio one rendered by sibling surfaces. */
export const REPLACE_MEDIA_ROW_ID_PREFIX = 'replace';

export interface ReplaceMediaControlsProps {
  mediaKind: ReplaceMediaKind;

  onSelect: (selection: ReplaceSourceSelection) => void;
}
